import LabelSystem from './LabelSystem';
import './LabelSystem.scss';

export default LabelSystem;
